<template>
    <div>
        <b-container fluid class="px-0 pb-2 team-page">
            <b-row>
                <b-col cols="" class="">
                    <b-row>
                        <b-col cols="">

                            <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
                                <h2 class="text-left mb-0">{{ $t('tireTracker.title') }}</h2>
                                <div class="justify-content-between justify-content-sm-center flex-wrap">
                                    <b-button @click="allowAddRecord = true"
                                        class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                                        variant="primary">
                                        <b-icon icon="plus" aria-hidden="true"></b-icon>
                                        <p class="mb-0 ml-2 text-white">{{ $t('tireTracker.addRecord') }}</p>
                                    </b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <div class="data-table team-data-table table-custom-border">
                                <div class="bg-white rounded">
                                    <div v-if="!isTableMounted" class="d-flex align-items-center px-3 py-3">
                                        <b-skeleton v-for="n in 2" :key="`tire-tab-skeleton-${n}`" width="80px"
                                            height="26px" class="mr-3 mb-0"></b-skeleton>
                                    </div>
                                    <v-tabs v-else class="team-tabs mb-0" show-arrows>
                                        <v-tab @click="setTab('tires')">{{ $t('tireTracker.tiresTab') }} <span
                                                class="f-12 ml-1"> ({{
                                                    tyresCount ?
                                                    tyresCount : 0 }})</span></v-tab>
                                        <v-tab @click="setTab('missing')">{{ $t('tireTracker.missingTab') }} <span
                                                class="f-12 ml-1"> ({{
                                                    missingTyreAccount ?
                                                    missingTyreAccount : 0 }})</span></v-tab>
                                    </v-tabs>
                                </div>
                                <div class="bg-white pt-3 pt-sm-4 rounded">
                                    <div class="table_row team_table_row">
                                        <div class="equipment-border filter-box" v-if="isTableMounted">
                                            <div class="d-flex mb-4 px-3 px-sm-4">
                                                <b-form-group class="text-left label font-weight-normal search-field mb-0">
                                                    <b-input-group class="username-input-field">
                                                        <b-form-input type="text"
                                                            :placeholder="$t('maintenanceShared.search')"
                                                            v-model="filterFields.search" class="unit f-12"
                                                            @keyup.enter="getTireTrackerData()"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button variant="primary" @click="getTireTrackerData()">
                                                                <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                                                        stroke="white" stroke-width="2"
                                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M10 10.5L13 13.5" stroke="white"
                                                                        stroke-width="2" stroke-linecap="round"
                                                                        stroke-linejoin="round" />
                                                                </svg>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                                <div class="ml-auto align-items-center d-none d-sm-flex flex-wrap">
                                                    <div class="position-relative">
                                                        <div class="position-absolute notification-badge"
                                                            v-if="activeFiltersCount">
                                                            {{ activeFiltersCount }}
                                                        </div>
                                                        <button class="btn btn-filter-section"
                                                            @click="$bvModal.show('modal-filter')">
                                                            <div class="d-flex align-items-center">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    class="lucide lucide-sliders-horizontal w-4 h-4"
                                                                    data-id="element-964">
                                                                    <line x1="21" x2="14" y1="4" y2="4"></line>
                                                                    <line x1="10" x2="3" y1="4" y2="4"></line>
                                                                    <line x1="21" x2="12" y1="12" y2="12"></line>
                                                                    <line x1="8" x2="3" y1="12" y2="12"></line>
                                                                    <line x1="21" x2="16" y1="20" y2="20"></line>
                                                                    <line x1="12" x2="3" y1="20" y2="20"></line>
                                                                    <line x1="14" x2="14" y1="2" y2="6"></line>
                                                                    <line x1="8" x2="8" y1="10" y2="14"></line>
                                                                    <line x1="16" x2="16" y1="18" y2="22"></line>
                                                                </svg>
                                                                <p class="mb-0 ml-2">{{ $t('maintenanceShared.filters') }}
                                                                </p>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="!isTableMounted" class="mt-2"
                                            style="height: calc(100vh - 240px); overflow: hidden;">
                                            <b-skeleton-table :rows="17" :columns="7"
                                                :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                                        </div>
                                        <b-table v-else ref="tableRef" class="mt-2" responsive :fields="fields"
                                            :sticky-header="'calc(100vh - 230px)'"
                                            :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                                            :no-local-sorting="true" :busy.sync="isBusy" :tbody-tr-class="'cursor-pointer'"
                                            :show-empty="emptyTable" :items="items">
                                            <template #cell(formatted_estimated_depth)="data">
                                                <span
                                                    :style="{ color: data.item.status === 'GOOD' ? '#2CCE89' : data.item.status === 'OOS' ? '#FF0000' : '#FFC800' }">{{
                                                        data.value }}</span>
                                            </template>
                                            <template #cell(action)="data">
                                                <div v-if="currentTab === 'tires'">
                                                    <svg @click="setTireTrackerData(data.item)" class="mr-4 cursor-pointer"
                                                        width="21" height="21" viewBox="0 0 21 21" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M7.9452 17.9664L1.71484 19.7109L3.45934 13.4806L14.8678 2.12751C14.9967 1.99564 15.1508 1.89086 15.3207 1.81932C15.4907 1.74779 15.6733 1.71094 15.8578 1.71094C16.0422 1.71094 16.2248 1.74779 16.3948 1.81932C16.5647 1.89086 16.7188 1.99564 16.8477 2.12751L19.2983 4.59196C19.428 4.72066 19.531 4.87381 19.6014 5.04251C19.6717 5.21123 19.7078 5.3922 19.7078 5.57497C19.7078 5.75774 19.6717 5.93871 19.6014 6.10743C19.531 6.27615 19.428 6.42928 19.2983 6.55798L7.9452 17.9664Z"
                                                            stroke="#2CCE89" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                    <svg @click="setShowDeletePopup(data.item)" class="cursor-pointer"
                                                        width="19" height="20" viewBox="0 0 19 20" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                        <path
                                                            d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path
                                                            d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path d="M7.23175 9.3065V14.8466" stroke="#FF0000"
                                                            stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                                <svg @click="setMissingData(data.item)" v-else class="cursor-pointer"
                                                    width="18" height="18" viewBox="0 0 18 18" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="9" cy="9" r="9" fill="#2D69F6" />
                                                    <path
                                                        d="M8.99951 11.9977V8.99768V11.9977ZM8.99951 8.99768V5.99768V8.99768ZM8.99951 8.99768H11.9995H8.99951ZM8.99951 8.99768H5.99951H8.99951Z"
                                                        fill="#2D69F6" />
                                                    <path
                                                        d="M8.99951 11.9977V8.99768M8.99951 8.99768V5.99768M8.99951 8.99768H11.9995M8.99951 8.99768H5.99951"
                                                        stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>

                                            </template>
                                        </b-table>
                                        <div class="entries-pagination px-0 px-sm-2" v-if="isTableMounted">
                                            <div class="d-flex align-items-center flex-wrap">
                                                <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                                                    <b-form-select v-model="perPage" :options="pageOptions" />
                                                </div>
                                                <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">
                                                    {{ positionText }}
                                                </p>
                                                <div class="pagination">
                                                    <b-pagination v-model="currentPage" :total-rows="rows"
                                                        :per-page="perPage" aria-controls="my-table"></b-pagination>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
        <b-modal id="modal-filter" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
            :body-class="'px-3 pt-3 pb-1'" no-close-on-esc>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('maintenanceShared.filters') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="body">
                <b-form-group :label="$t('maintenanceShared.type')" class="text-left select_arrow label mb-0">
                    <b-form-select class="input f-12 mb-3" :options="typeFilterOptions" v-model="filterFields.type"
                        @change="getTireTrackerData()"></b-form-select>
                </b-form-group>
                <b-form-group :label="$t('maintenanceShared.status')" class="text-left select_arrow label mb-0"
                    v-if="currentTab === 'tires'">
                    <b-form-select class="input f-12 mb-3" :options="[
                        {
                            value: '',
                            text: '',
                        },
                        {
                            value: 'OOS',
                            text: 'OOS',
                        },
                        {
                            value: 'NEED_REPLACE',
                            text: 'Need Replace',
                        },
                        {
                            value: 'GOOD',
                            text: 'Good',
                        }
                    ]" v-model="filterFields.status" @change="getTireTrackerData()"></b-form-select>
                </b-form-group>
            </div>
            <template #modal-footer="">
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary"
                        @click="resetFilterFields(); $bvModal.hide('modal-filter')">{{ $t('maintenanceShared.reset')
                        }}</b-button>
                    <b-button class="mx-0 h-40px w-100px m-0 m-0" block @click="$bvModal.hide('modal-filter')">{{
                        $t('maintenanceShared.close') }}</b-button>
                </div>
            </template>
        </b-modal>
        <DeleteModal v-if="showDeletePopup" @confirm="deleteData($event)" />
        <AddAndUpdateTireTracker :id="equipId" :tiresRecordData="tireTrackerData" :allowAddRecord="allowAddRecord"
            @close="allowAddRecord = false; tireTrackerData = null; equipId = null"
            @tiresDataUpdated="getTireTrackerData" />
    </div>
</template>
<script>
import * as moment from "moment-timezone";
import DeleteModal from "@/components/DeleteModal.vue";
import { mapActions, mapGetters } from "vuex";
import AddAndUpdateTireTracker from "@/components/Maintenance/AddAndUpdateTireTracker.vue";
export default {
    name: "TireTracker",
    components: { DeleteModal, AddAndUpdateTireTracker },
    data() {
        return {
            items: [],
            isBusy: false,
            tireTrackerId: null,
            allowAddRecord: false,
            equipId: null,
            isTableMounted: false,
            showDeletePopup: false,
            emptyTable: false,
            rows: 0,
            tireTrackerData: null,
            currentTab: 'tires',
            positionText: '',
            missingTyreAccount: 0,
            tyresCount: 0,
            perPage: 10,
            currentPage: 1,
            sortBy: '',
            sortDesc: false,
            filterFields: {
                search: '',
                type: '',
                status: ''
            },
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
        }
    },
    computed: {
        ...mapGetters(["userCompany"]),
        typeFilterOptions() {
            return [
                { value: '', text: '' },
                { value: 'Vehicle', text: this.$t('maintenanceShared.vehicle') },
                { value: 'Trailer', text: this.$t('maintenanceShared.trailer') },
            ];
        },
        activeFiltersCount() {
            return Object.keys(this.filterFields).reduce((count, key) => {
                if (
                    this.filterFields[key] !== '' &&
                    this.filterFields[key] !== null
                ) {
                    return count + 1;
                }
                return count;
            }, 0);
        },
        fields() {
            return [
                {
                    label: "Unit #",
                    key: "unit_no",
                    sortable: true,
                    thClass: 'font-table-weight-bold',
                    stickyColumn: true,
                    thStyle: { width: "200px" },
                },
                {
                    key: "type",
                    label: "Type",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                ...this.currentTab === 'missing' ? [] : [
                    {
                        key: "tire_updated_at",
                        label: "Updated",
                        sortable: true,
                        thClass: 'font-table-weight-bold'
                    },
                    {
                        key: "tire_position",
                        label: "Tire Positions",
                        sortable: true,
                        thClass: 'font-table-weight-bold'
                    },
                    {
                        key: "tread_depth",
                        label: "Tread Depth",
                        sortable: true,
                        thClass: 'font-table-weight-bold'
                    },
                    {
                        key: "formatted_estimated_depth",
                        label: "Est. Current Depth",
                        sortable: true,
                        thClass: 'font-table-weight-bold'
                    }
                ],
                {
                    key: "action",
                    label: "Action",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
            ]
        }
    },
    watch: {
        perPage: {
            async handler() {
                await this.getTireTrackerData();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getTireTrackerData();
            },
        },
        sortBy: {
            async handler() {
                await this.getTireTrackerData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getTireTrackerData();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        },
    },
    methods: {
        ...mapActions(["getAllTireTrackerData", "setNotification", "deleteTireData"]),
        setMissingData(data) {
            this.tireTrackerData = data;
            this.allowAddRecord = true
        },
        setTireTrackerData(data) {
            this.equipId = data.unit_id;
            this.allowAddRecord = true;
        },
        setShowDeletePopup(data) {
            this.showDeletePopup = true;
            this.tireTrackerId = data.id;
            this.equipId = data.unit_id
        },
        async deleteData(status) {
            if (status) {
                try {
                    await this.deleteTireData({ equipID: this.equipId });
                    await this.setNotification({
                        msg: this.$t('tireTracker.deleted'),
                        type: "success",
                        color: "green",
                    });
                    this.tireTrackerId = null
                    this.equipId = null
                    this.showDeletePopup = false;
                    await this.getTireTrackerData()
                }
                catch (error) {
                    this.tireTrackerId = null
                    this.equipId = null
                    this.showDeletePopup = false;
                    if (typeof error === "object" && error.error) {
                        await this.setNotification({
                            msg: error.error,
                            type: "error",
                            color: "red",
                        });
                    }
                }
            }
            else this.showDeletePopup = false
        },
        setTab(tab) {
            this.currentTab = tab
            this.resetFilterFields();
        },
        async resetFilterFields() {
            this.filterFields = {
                search: '',
                type: '',
                status: ''
            }
            await this.getTireTrackerData();
        },
        async getTireTrackerData() {
            try {
                this.isBusy = true
                let url = ""
                Object.keys(this.filterFields).map((key) => {
                    if (this.filterFields[key] !== '') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=${this.currentTab === 'missing' ? 'unit_no' : 'formatted_estimated_depth'}&sort_order=asc&`
                }

                url += `page=${this.currentPage}&page_size=${this.perPage}`
                const data = await this.getAllTireTrackerData({ url, company_id: this.userCompany, currentTab: this.currentTab });
                this.missingTyreAccount = data?.counts?.missing >= 0 ? data?.counts?.missing : data.total_entries_count;
                this.tyresCount = data?.counts?.tires >= 0 ? data?.counts?.tires : data.total_entries_count;
                this.items = []
                if (data.total_entries_count) {
                    if (this.currentTab === 'missing') {
                        data.data.forEach((item) => {
                            this.items.push({
                                id: item.id,
                                unit_no: item.unit_no,
                                type: item.type
                            })
                        })
                    }
                    else {
                        data.data.forEach((item) => {
                            this.items.push({
                                id: item.id,
                                unit_no: item.unit_info ? item.unit_info.unit_no : '-',
                                unit_id: item.unit_info ? item.unit_info.id : null,
                                type: item.unit_info ? item.unit_info.type : '-',
                                tire_position: item.tire_position,
                                tread_depth: item.formatted_depth,
                                formatted_estimated_depth: item.formatted_estimated_depth,
                                tire_updated_at: item.tire_updated_at ? moment(item.tire_updated_at).format('ll') : 'N/A',
                                status: item.status
                            })
                        })
                    }
                    this.rows = data.total_entries_count
                    this.positionText = `${this.currentPage === 1 ? `1` : `${(this.perPage * (this.currentPage - 1)) + 1}`} - ${this.perPage * (this.currentPage - 1) + data.queryset_count} of ${data.total_entries_count}`
                }
                else {
                    this.rows = 0
                    this.positionText = `0 - 0 of 0`
                }
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                this.isBusy = false
                this.isTableMounted = true
                console.log(e)
            }
        }
    },
    mounted() {

    }
}
</script>